<template>
  <div class="guide">
    <div v-if="showGuide" class="step-container">
      <div class="step1" v-show="step === 1">
        <div class="main-box">
          <div class="box"><span class="ab-center">主画面</span></div>
        </div>
        <div class="sub-box">
          <div class="box"><span class="ab-center">副画面</span></div>
        </div>
        <div class="item"><span>1.</span>单击副画面，主副画面进行切换</div>
        <div class="item"><span>2.</span>双击副画面，可以放大；继续双击副画面，可以缩小</div>
        <div class="next-btn" @click="step = 2">下一步</div>
      </div>
      <div class="step2" v-show="step === 2">
        <div class="guide-arrow">
          <img src="@/assets/image/guide-arrows.png" alt="" />
        </div>
        <div class="guide-set">
          <img src="@/assets/image/guide-4.png" alt="" />
        </div>
        <div class="step-info-container">
          <div class="item"><span>3.</span>点击主画面右下角设置画面</div>
          <div class="item"><span>4.</span>选择要控制的画面</div>
          <div class="screen-container">
            <div class="left">
              <span class="ab-center">主画面</span>
            </div>
            <div class="right">
              <span class="ab-center">副画面</span>
            </div>
          </div>
          <div class="step-control">
            <div>
              <span>画面</span>
              <div class="switch"></div>
            </div>
            <div>
              <span>画面</span>
              <div class="switch"></div>
            </div>
          </div>
          <div class="next-btn" @click="handleCloseStep">我知道了</div>
        </div>
      </div>
    </div>

    <div v-if="showGuideBar && !inputFocus" @click="handle2Guide" class="guide-bar">
      <div>
        <van-icon name="question" />
        <span>操作指南</span>
      </div>
      <van-icon @click.stop="closeGuide" name="cross" />
    </div>
  </div>
</template>

<script>
import {getIsIOS} from '@/ultis'
export default {
  data() {
    const isIOS = getIsIOS()
    return {
      showGuideBarSelf: true,
      showGuide: false,
      step: 1,
      isIOS,
      originHeight: document.documentElement.clientHeight || document.body.clientHeight,
      inputFocus: false
    }
  },
  mounted() {
    if (this.isIOS) {
      document.body.addEventListener('focusin', () => {
        this.inputFocus = true
      })
      document.body.addEventListener('focusout', () => {
        this.inputFocus = false
      })
    } else {
      window.addEventListener('resize', () => {
        const currentHeight = document.documentElement.clientHeight || document.body.clientHeight
        if (this.originHeight - currentHeight > 50) {
          this.inputFocus = true
        } else {
          this.inputFocus = false
        }
      })
    }
  },
  computed: {
    video() {
      return this.$store.state.activePlay.video
    },
    showGuideBar() {
      return this.video.doubleUrl && this.showGuideBarSelf
    }
  },
  methods: {
    handle2Guide() {
      this.showGuide = true
    },
    handleCloseStep() {
      this.showGuide = false
      this.step = 1
    },
    closeGuide() {
      this.showGuideBarSelf = false
    }
  }
}
</script>

<style scoped lang="scss">
.guide {
}
.guide-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;
  height: 38px;
  background: #fda423;
  padding: 0 16px;
  i,
  span {
    vertical-align: middle;
  }
  span {
    margin-left: 8px;
  }
}

.step-container {
  position: absolute;
  z-index: 100;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 5, 26, 0.4);
  .step1 .main-box {
    padding: 4px;
    .box {
      position: relative;
      height: 212px;
      border: 2px dashed #ffffff;
      border-radius: 6px;
      color: #fff;
    }
  }
  .step1 .sub-box {
    float: right;
    padding: 4px;
    .box {
      position: relative;
      height: 62px;
      width: 120px;
      border: 2px dashed #ffffff;
      border-radius: 6px;
      color: #fff;
    }
  }
  .step1 .item {
    clear: both;
    width: 80%;
    margin: 0 auto;
    padding: 15px 0;
    color: #fff;
    padding-left: 20px;
    position: relative;
    span {
      position: absolute;
      left: 0;
      color: rgba(253, 164, 35, 1);
    }
  }
  .step2 {
    .guide-arrow {
      width: 100px;
      position: absolute;
      right: 60px;
      top: 195px;
      img {
        width: 100%;
      }
    }
    .guide-set {
      width: 36px;
      position: absolute;
      right: 20px;
      top: 180px;
      img {
        width: 100%;
      }
    }
    .step-info-container {
      position: absolute;
      top: 280px;
      width: 100%;
      .item {
        width: 80%;
        margin: 0 auto;
        padding: 10px 0;
        color: #fff;
        padding-left: 20px;
        position: relative;
        span {
          position: absolute;
          left: 0;
          top: 12px;
          color: rgba(253, 164, 35, 1);
        }
      }
      .screen-container {
        display: flex;
        margin: 0 auto;
        justify-content: space-between;
        width: 80%;
        div {
          width: 48%;
          height: 80px;
          background: #d2dafc;
          border-radius: 8px;
          color: #4465f3;
          position: relative;
        }
      }
      .step-control {
        width: 80%;
        margin: 0 auto 40px;
        & > div {
          display: inline-block;
          text-align: center;
          width: 50%;
          margin-top: 10px;
          span {
            color: #fff;
            margin-right: 10px;
          }
        }
        .switch {
          vertical-align: middle;
          display: inline-block;
          position: relative;
          width: 52px;
          height: 28px;
          background: #4465f3;
          border-radius: 14px;
          &::after {
            content: '';
            position: absolute;
            right: 2px;
            top: 2px;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #fff;
          }
        }
      }
    }
  }
  .next-btn {
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 50px;
    width: 120px;
    height: 60px;
    background: url('./../../../assets/image/guide-btn.png') no-repeat;
    background-size: contain;
    margin: 20px auto;
  }
}
</style>
